/**
 * Onde o cartão automático de instalação pode aparecer (CONV-01) e qual nome
 * de app o convite mostra (GUIA-02).
 *
 * O cartão só aparece no admin e na área do cliente: nas páginas públicas ele
 * atrapalharia quem está agendando (decisão de produto de 05/10/2026).
 */

function normalizePathname(pathname: string | null | undefined): string {
  if (!pathname) return "";
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed || "/";
}

function isAdminPath(pathname: string): boolean {
  return pathname === "/admin" || pathname.startsWith("/admin/");
}

export function shouldShowAutoInstallCard(pathname: string | null | undefined): boolean {
  const path = normalizePathname(pathname);
  return isAdminPath(path) || path === "/cliente/area";
}

export function resolveInstallAppName({
  pathname,
  brandName,
}: {
  pathname: string | null | undefined;
  brandName?: string | null;
}): string {
  if (isAdminPath(normalizePathname(pathname))) return "Agiliza Admin";

  const brand = brandName?.trim();
  return brand || "Agiliza";
}
